import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export interface BankSwiftCode {
    id: string;
    bic: string;
    bank: string;
}

const normalize = (response: any) => {
    if (response?.data?._result) return response;
    const items = response?.data?.data ?? [];
    const total = response?.data?.total ?? items.length;
    response.data = {_result: {items, total}};
    return response;
};

export const getBankSwiftCodes = async (filters: any = {}) => {
    const qs = FilterBuilder.hashMapToQueryString(filters);
    const response = await http.get('/bank-swift-codes' + (qs ? '?' + qs : ''));
    return normalize(response);
};

export const getBankSwiftCodeDetail = async (id: string) => {
    return await http.get('/bank-swift-codes/' + id);
};
